import { match } from "ts-pattern";

/**
 * TenantScope type - matches the schema in a3s-provisioning.
 * Defined here to avoid circular dependency.
 */
export type TenantScope =
  | { kind: "customer"; id: string; name: string | null }
  | { kind: "branch"; code: string; name: string | null }
  | { kind: "test"; unique: string };

/**
 * Derives a canonical string key from a TenantScope.
 * Used as input to rendezvous hashing for deterministic realm selection.
 *
 * @param scope - The tenant scope to convert
 * @returns A unique string key for the scope
 */
export const scopeToKey = (scope: TenantScope): string =>
  match(scope)
    .with({ kind: "customer" }, (s) => `customer:${s.id}`)
    .with({ kind: "branch" }, (s) => `branch:${s.code}`)
    .with({ kind: "test" }, (s) => `test:${s.unique}`)
    .exhaustive();
